'use client';

import { useEffect } from 'react';
import { setSentryUser } from '../../utils/sentry/setSentryUser';

/**
 * Client component that sets Sentry user info on mount
 * This ensures user info is set on page load (F5 reload)
 */
export function SentryUserProvider() {
  useEffect(() => {
    setSentryUser();
  }, []);

  return null;
}
